import axios from 'axios'
import _find from 'lodash/find'
import Logger from 'utils/logging'
import Slugger from 'github-slugger'
import getConfig from 'config/web'
import SectionType from 'models/types/ts/sectionType'

const { articlesApiUrl } = getConfig()

export function slugifySections(
    sections: Array<SectionType>
): Array<SectionType> {
    const slugger = new Slugger()
    return sections.map((item) => {
        const slug = slugger.slug(item.headline)
        return {
            ...item,
            slug,
        }
    })
}

/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export function findSectionByIdentifier(
    sections: Array<SectionType>,
    identifier: string | string[]
): SectionType {
    return _find(sections, (section) =>
        Array.isArray(identifier)
            ? identifier.includes(section.identifier)
            : section && section.identifier === identifier
    )
}

// TODO: Temporary hack to display EN content when passing JA into the articles API
function returnEnDefaultlang(language: string): string {
    // arrey of languages that our articles api does support
    const { supportedLanguagesInArticlesApi } = getConfig()

    // if language is not supported, return en
    if (!supportedLanguagesInArticlesApi.includes(language)) {
        return 'en'
    }
    return language
}

/**
 * TODO, code can be improved, missing .then and .catch and logging and just not proper data handling
 * @param subpage The slug of the article to get
 * @param language The language to get the article in
 * @returns Returns an article
 */
export async function fetchArticle(subpage: string, language: string) {
    const { data } = await axios.get(
        `${articlesApiUrl}/${subpage}?lang=${returnEnDefaultlang(language)}`
    )
    if (!data) {
        return null
    }

    return data
}
